import { render } from "./HelpFormSwitch.vue?vue&type=template&id=34610161"
import script from "./HelpFormSwitch.vue?vue&type=script&lang=js"
export * from "./HelpFormSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__